// EventTicket.js

import { Button } from "@mui/material";
import React from "react";

const EventTicket = () => {
  return (
    <>
      <div className="event-ticket">
        <div className="text-end">
          <Button onClick={window.print} variant="contained" className="my-2 ">
            Download
          </Button>
        </div>
        <div className="row">
          <div className="col">
            <img
              src="https://www.oyorooms.com/blog/wp-content/uploads/2018/02/type-of-event.jpg"
              alt=""
              className="img-fluid"
            />
          </div>
          <div className="col ticket-header align-self-center">
            <h2>Title</h2>
            <p>
              <b>Date</b> | saturday, 3 jan
            </p>
            <p>
              <b>Venue</b> | Lorem ipsum dolor sit amet, consectetur adipisicing
              elit. Cupiditate, voluptatum!
            </p>
            <p>
              <b>Time </b> | 3.00 pm
            </p>
            <hr />

            <div className="ticket-details">
              <h3>Ticket Details</h3>
              <p>
                <strong>Name:</strong> Gauri Birari
              </p>
              <p>
                <strong>Email:</strong> gauri@gmail.com
              </p>
              <p>
                <strong>Contact Number:</strong> 988787878778
              </p>
              <p>
                <strong>Ticket Type:</strong> lorem
              </p>
              {/* Add other ticket details */}
            </div>
          </div>
        </div>

        <div className="ticket-qrcode">
          {/* <img
          src={`https://api.qrserver.com/v1/create-qr-code/?data=${ticket.qrCodeData}&size=100x100`}
          alt="QR Code"
        /> */}
        </div>
      </div>
    </>
  );
};

export default EventTicket;
